import { getTotalPlayers } from "core-integration/src/store/game/reducers";
import ButtonLink from "plos/src/components/links/ButtonLink";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useTrackingContext } from "../../../contexts/TrackingContext";
import { ChevronRight } from "../../icons/Chevrons";
import {
  dataList,
  dataListHeading,
  dataListItem,
  dataListValue,
} from "../entryInfo.css";
import EntryInfoPanel from "../EntryInfoPanel";
import { PointsAndRankingsProps } from "./types";

const PointsAndRankings = ({ entry }: PointsAndRankingsProps) => {
  const { t } = useTranslation("status");
  const { fireClickTrackEvent } = useTrackingContext();

  const totalPlayers = useSelector(getTotalPlayers);

  const trackGameweekHistory = () => {
    fireClickTrackEvent({
      event_component: "button click",
      event_category: "fantasy points and ranking",
      event_detail: "Gameweek History",
    });
  };

  const headerAction = (
    <ButtonLink
      appearance="tonal"
      size="small"
      to={`/entry/${entry.id}/history`}
      onClick={trackGameweekHistory}
    >
      {t("gameweekHistory", "Gameweek History")}
      <ChevronRight height={10} width={10} />
    </ButtonLink>
  );

  return (
    <EntryInfoPanel
      title={t("pointsRankings", "Points & Rankings")}
      headerAction={headerAction}
    >
      <dl className={dataList}>
        {entry.summary_overall_points != null && (
          <div className={dataListItem}>
            <dt className={dataListHeading}>
              {t("overallPoints", "Overall points")}
            </dt>
            <dd className={dataListValue}>
              {entry.summary_overall_points.toLocaleString()}
            </dd>
          </div>
        )}
        {entry.summary_overall_rank != null && (
          <div className={dataListItem}>
            <dt className={dataListHeading}>
              {t("overallRank", "Overall rank")}
            </dt>
            <dd className={dataListValue}>
              {entry.summary_overall_rank.toLocaleString()}
            </dd>
          </div>
        )}
        <div className={dataListItem}>
          <dt className={dataListHeading}>
            {t("totalPlayers", "Total players")}
          </dt>
          <dd className={dataListValue}>{totalPlayers?.toLocaleString()}</dd>
        </div>
        {entry.summary_event_points != null && (
          <div className={dataListItem}>
            <dt className={dataListHeading}>
              {t("gameweekPoints", "Gameweek points")}
            </dt>
            <dd className={dataListValue}>{entry.summary_event_points}</dd>
          </div>
        )}
      </dl>
    </EntryInfoPanel>
  );
};

export default PointsAndRankings;
